import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "h-full p-8 overflow-y-scroll" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_3 = {
  class: "flex flex-col p-4 rounded bg-primary-dark",
  "data-testid": "watch-board-container"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "p-4 pt-0 pl-0 text-2xl" }, "Watch Board", -1)
const _hoisted_5 = {
  key: 0,
  class: "grid grid-cols-2 grid-rows-1 gap-4"
}
const _hoisted_6 = {
  key: 1,
  class: "h-full bg-primary-dark"
}
const _hoisted_7 = {
  key: 0,
  class: "grid grid-cols-4 gap-4 mt-4"
}
const _hoisted_8 = {
  key: 1,
  class: "py-16 mt-4 bg-primary-dark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_class_metrics_table_component = _resolveComponent("class-metrics-table-component")
  const _component_student_trending_card_component = _resolveComponent("student-trending-card-component")
  const _component_zero_landing_component = _resolveComponent("zero-landing-component")
  const _component_student_metric_card = _resolveComponent("student-metric-card")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_class_metrics_table_component, {
        classMetrics: _ctx.classMetrics,
        class: "rounded shadow-md bg-primary-dark",
        "data-testid": "class-metrics-table"
      }, null, 8, ["classMetrics"]),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.students.length)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_student_trending_card_component, {
                student: _ctx.students[1],
                chartData: _ctx.students[1].historicalData,
                classData: _ctx.getStudentClass(_ctx.students[1]),
                class: "border rounded shadow-md cursor-pointer bg-primary-dark hover:border-blue-500",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleStudentSelected(_ctx.students[1]))),
                "data-testid": "student-trending-card-0"
              }, null, 8, ["student", "chartData", "classData"]),
              _createVNode(_component_student_trending_card_component, {
                student: _ctx.students[0],
                chartData: _ctx.students[0].historicalData,
                classData: _ctx.getStudentClass(_ctx.students[0]),
                class: "border rounded shadow-md cursor-pointer bg-primary-dark hover:border-blue-500",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleStudentSelected(_ctx.students[0]))),
                "data-testid": "student-trending-card-1"
              }, null, 8, ["student", "chartData", "classData"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode(_component_zero_landing_component, { message: "No student data available" })
            ]))
      ])
    ]),
    (_ctx.students.length)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.students, (student, index) => {
            return (_openBlock(), _createBlock(_component_student_metric_card, {
              class: "border-4 border-transparent rounded shadow-md cursor-pointer bg-primary-dark hover:border-blue-500",
              onClick: ($event: any) => (_ctx.handleStudentSelected(student)),
              key: index,
              student: student,
              classData: _ctx.getStudentClass(student),
              "data-testid": `student-metric-card-${student.id}`
            }, null, 8, ["onClick", "student", "classData", "data-testid"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode(_component_zero_landing_component, { message: "No student data available" })
        ]))
  ]))
}